import { render, staticRenderFns } from "./ChangeAccountPassword.vue?vue&type=template&id=6e55805e&scoped=true"
import script from "./ChangeAccountPassword.vue?vue&type=script&lang=js"
export * from "./ChangeAccountPassword.vue?vue&type=script&lang=js"
import style0 from "./ChangeAccountPassword.vue?vue&type=style&index=0&id=6e55805e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e55805e",
  null
  
)

export default component.exports